import { useDebouncedValue } from '@mantine/hooks'
import { useMemo } from 'react'

import useGeocoder from '../../../components/Geocoder/useGeocoder'
import { isProbablyBarcode } from '../utils'

type TUseRemoteResultsProps = {
  text: string
  lonlat: [number, number]
}

type TUseRemoteResults = {}

export function useRemoteResults({
  text,
  lonlat,
}: TUseRemoteResultsProps): any[] {
  const [debouncedText] = useDebouncedValue(text, 500)

  const { error, isLoading, results } = useGeocoder({
    query: debouncedText,
    lat: lonlat[1],
    lon: lonlat[0],
    limit: 5,
  })

  const result = useMemo(() => {
    if (
      !debouncedText ||
      debouncedText.length < 3 ||
      isProbablyBarcode(debouncedText)
    ) {
      return []
    }

    if (isLoading) {
      const label = i18n.t(`search_result`, `Suchergebnisse`)
      return [
        {
          item: {
            name1: i18n.t(
              'addresses_being_searched',
              'Adressen werden gesucht',
            ),
          },
          value: label,
          disabled: true,
          isLoading,
          group: label,
        },
      ]
    }
    // if (isEmpty(results)) {
    //   return [
    //     {
    //       value: {
    //         name1: 'Keine Ergebnisse',
    //       },
    //       disabled: true,
    //       isLoading,
    //       group: 'Suchergebnisse',
    //     },
    //   ]
    // }

    return results.map((result) => ({
      value: result.title,
      item: {
        name1: result.title,
        lonlat: [result.position.lng, result.position.lat],
      },
      group: 'Suchergebnisse',
    }))
  }, [results, isLoading])

  return result as any[]
}
